<template>
  <JobList :dispatch-mode="true"/>
</template>

<script>
import JobList from "./JobList"
export default {
  name: "Jobs",
  components: {
    JobList
  }
}
</script>

<style scoped>

</style>